import {
    type Element,
    PathApi,
    type SlateEditor,
} from '@udecode/plate';

import { BaseFigureCaptionPlugin } from '../FigureCaptionBasePlugin';
import type { FigureKind, TFigureCaptionElement } from '../types';

export const insertFigureCaption = (
    editor: SlateEditor,
    at: Element,
    figureKind: FigureKind,
    position: 'above' | 'below'
) => {
    const type = editor.getType(BaseFigureCaptionPlugin);

    editor.tf.withoutNormalizing(() => {
        const atPath = editor.api.path(at)!;

        const before = atPath;
        const after = PathApi.next(atPath);

        const insertAt = position === 'above' ? before : after;

        editor.tf.insertNodes<TFigureCaptionElement>({
            type,
            children: [{ text: 'Zde vložte popisek' }],
            align: 'left',
            figureKind
        }, {
            at: insertAt,
            select: true
        });
    });
};
